import React from "react";



const IntroPage: React.FC = () => {
  return (
    <div
      className="items-start  w-full h-full "
     
    >
      <div className="flex flex-col gap-y-[12px] md:w-[542px] items-start md:pt-[30px] md:pb-[40px]">
      <div className="common-title">Welcome Aboard! 🚀</div>
      <div className="common-sub-text">Hey there! We’re thrilled to have you take the first step in expanding your brand to exciting new markets. 🌍 To ensure we connect you with the right partners, we’d love to know more about your brand. <br/><br/>It won’t take long—just a few quick details to get started. Let’s go!</div>

      </div>
      
            
           
    </div>
  );
};

export default IntroPage;
